import {Controller} from "stimulus"
import {TimelineLite} from "gsap/TimelineLite"
import {TweenLite} from "gsap/TweenLite"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "target",
    ]

    initialize() {
        let allFoldableSections = document.querySelectorAll('.foldable-section');
        if(allFoldableSections[0]){
            allFoldableSections[0].classList.toggle("is-active");
        }
    }

    toggle(e){
        let parent = e.currentTarget.parentNode;

        if(parent.classList.contains("is-active")){
            parent.classList.toggle("is-active");
        }else{
            let activeFoldableSections = document.querySelectorAll('.foldable-section');
            [].forEach.call(activeFoldableSections, function(el) {
                el.classList.remove("is-active");
            });
            parent.classList.toggle("is-active");
        }

        function getCoords(elem) { // crossbrowser version
            let box = elem.getBoundingClientRect();

            let body = document.body;
            let docEl = document.documentElement;

            let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

            let clientTop = docEl.clientTop || body.clientTop || 0;

            let top  = box.top +  scrollTop - clientTop;

            return top;
        }


    }



}
